<template>
  <v-card class="pa-2" v-if="(teavitused && teavitused.length > 0) || isLoading">
    <h3 class="pealkiri text-uppercase text-no-wrap">
      <v-icon icon="mdi-alert-box" size="48"></v-icon>
      Tähelepanu
    </h3>
    <div class="text-center" v-if="isLoading">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <v-timeline v-if="!isLoading" density="compact" class="ml-2" truncate-line="end" side="end" align="start">
      <v-timeline-item dot-color="var(--varv-lisa-1)" v-for="(teavitus, index) in teavitused" :key="index" size="small">
        <div>
          {{ teavitus }}
        </div>
      </v-timeline-item>
    </v-timeline>

  </v-card>
</template>

<style scoped>
.pealkiri {
  color: var(--varv-lisa-1);
  font-size: 22px;
}
</style>

<script lang="ts">
import { TeavitusteTeenus } from '@/core/teavitused-teenus';
import { defineComponent } from 'vue';
import moment from 'moment';
import mixin from '@/core/mixins';
import { erandid } from '@/core/erandid';
import { useTeavitusedStore } from '@/stores/teavitusedStore';

const _teavitusteTeenus = new TeavitusteTeenus();

export default defineComponent({
  name: 'TahelepanuTeavitused',
  data() {
    return {
      teavitused: new Array<string>(),
      moment: moment,
      isLoading: false,
    }
  },
  mixins: [mixin],
  methods: {
    minuTeavitusteInfo() {
      if (this.teavitusedStore.teavitusedSaadud) {
        Object.assign(this.teavitused, this.teavitusedStore.teavitused);
        this.isLoading = false;
      }
      else {
        this.isLoading = true;
      }

      _teavitusteTeenus.annaMinuTeavitused().then((teavitused) => {
        this.teavitusedStore.satiTeavitused(teavitused);
        this.teavitused = teavitused;
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  created() {
    this.moment = moment
  },
  mounted() {
    this.minuTeavitusteInfo();
  },
  setup() {
    return {
      erandid,
      teavitusedStore: useTeavitusedStore()
    }
  }
}
);
</script>